import { AntragLimit } from '../model';
import { EinreichungApiService } from './einreichung-api.service';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AntragsLimitService {
  private einreichungApiService = inject(EinreichungApiService);

  public getAntragsLimit(): Observable<AntragLimit> {
    return this.einreichungApiService.getAntragsLimit();
  }

  public isLimitReached(): Observable<boolean> {
    return this.getAntragsLimit().pipe(
      map((antragLimit) => antragLimit.isLimited && antragLimit.antraegeLeftToday === 0),
    );
  }
}
